export function setState(state, keyValue = []) {
  if (!Array.isArray(keyValue)) {
    return;
  }
  state[keyValue[0]] = keyValue[1];
}

export function setLeases(state, leases) {
  state.leases = leases;
}

export function setLease(state, lease) {
  state.lease = lease;
}

export function setSelectedLease(state, lease) {
  state.selectedLease = lease;
}

export function deliveryMessageShownTo(state, leaseId) {
  state.deliveryMessageShown = {
    ...state.deliveryMessageShown,
    [leaseId]: true
  };
}
